/* ═══════════════════════════════════════════
   MOKSHA MANDIR - Theme JS (clean, no GSAP)
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  initScrollProgress();
  initHeader();
  initFAQ();
  initCartDrawer();
  initMobileNav();
  initReviewsCarousel();
  initHeroCarousel();
  initPdpGallery();
  initPdpQty();
  initPdpVariants();
  initPdpTabs();
  initPdpCountdown();
  initPdpBuyNow();
  initPdpShare();
});

/* ── Scroll Progress Bar ── */
function initScrollProgress() {
  const bar = document.querySelector('.scroll-progress');
  if (!bar) return;
  window.addEventListener('scroll', () => {
    const h = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = h > 0 ? (window.scrollY / h * 100) + '%' : '0%';
  }, { passive: true });
}

/* ── Sticky Header ── */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const check = () => header.classList.toggle('is-scrolled', window.scrollY > 60);
  window.addEventListener('scroll', check, { passive: true });
  check();
}

/* ── FAQ Accordion ── */
function initFAQ() {
  document.querySelectorAll('.faq__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq__item');
      const answer = item.querySelector('.faq__answer');
      const isOpen = item.classList.contains('is-open');

      const section = item.closest('section') || item.closest('.faq__columns');
      if (section) {
        section.querySelectorAll('.faq__item.is-open').forEach(open => {
          if (open !== item) {
            open.classList.remove('is-open');
            open.querySelector('.faq__answer').style.maxHeight = '0';
          }
        });
      }

      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = '0';
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  document.querySelectorAll('.faq__filter').forEach(btn => {
    btn.addEventListener('click', () => {
      const category = btn.dataset.category;
      const container = btn.closest('.faq') || btn.closest('section');
      btn.closest('.faq__filters').querySelectorAll('.faq__filter').forEach(f => f.classList.remove('is-active'));
      btn.classList.add('is-active');
      container.querySelectorAll('.faq__item').forEach(item => {
        item.style.display = (category === 'all' || item.dataset.category === category) ? '' : 'none';
      });
    });
  });
}

/* ── Cart Drawer ── */
function initCartDrawer() {
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  if (!drawer) return;

  document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      drawer.classList.toggle('is-open');
      if (overlay) overlay.classList.toggle('is-open');
      document.body.style.overflow = drawer.classList.contains('is-open') ? 'hidden' : '';
    });
  });

  if (overlay) overlay.addEventListener('click', closeCart);
  document.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));

  function closeCart() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

/* ── Reviews Carousel ── */
function initReviewsCarousel() {
  document.querySelectorAll('[data-reviews-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-reviews-track]');
    const prev = carousel.querySelector('[data-reviews-prev]');
    const next = carousel.querySelector('[data-reviews-next]');
    if (!track) return;

    const getCardWidth = () => {
      const card = track.querySelector('.review-card');
      if (!card) return 340;
      const style = getComputedStyle(track);
      const gap = parseInt(style.gap) || 20;
      return card.offsetWidth + gap;
    };

    const scrollBy = (dir) => {
      const w = getCardWidth();
      track.parentElement.scrollBy({ left: dir * w * 3, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => scrollBy(-1));
    if (next) next.addEventListener('click', () => scrollBy(1));
  });
}

/* ── Hero Product Carousel (arrows + dots) ── */
function initHeroCarousel() {
  const wrap = document.querySelector('.hero__products-wrap');
  if (!wrap) return;
  const container = wrap.querySelector('[data-hero-carousel]');
  const prev = wrap.querySelector('[data-hero-prev]');
  const next = wrap.querySelector('[data-hero-next]');
  const dots = wrap.querySelectorAll('.hero__dot');
  const cards = wrap.querySelectorAll('.hero__pcard');
  if (!container || cards.length === 0) return;

  const getCardWidth = () => {
    const style = getComputedStyle(wrap.querySelector('.hero__products-track'));
    const gap = parseInt(style.gap) || 16;
    return cards[0].offsetWidth + gap;
  };

  const scrollToIndex = (i) => {
    const w = getCardWidth();
    container.scrollTo({ left: i * w, behavior: 'smooth' });
  };

  const updateDots = () => {
    const w = getCardWidth();
    const idx = Math.round(container.scrollLeft / w);
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
  };

  if (prev) prev.addEventListener('click', () => {
    const w = getCardWidth();
    const idx = Math.round(container.scrollLeft / w);
    scrollToIndex(Math.max(0, idx - 1));
  });

  if (next) next.addEventListener('click', () => {
    const w = getCardWidth();
    const idx = Math.round(container.scrollLeft / w);
    scrollToIndex(Math.min(cards.length - 1, idx + 1));
  });

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      scrollToIndex(parseInt(dot.dataset.dot));
    });
  });

  container.addEventListener('scroll', updateDots, { passive: true });
}


/* ── PDP Gallery ── */
function initPdpGallery() {
  const gallery = document.querySelector('[data-pdp-gallery]');
  if (!gallery) return;
  const slides = gallery.querySelectorAll('.pdp__gallery-slide');
  const thumbs = document.querySelectorAll('.pdp__thumb');
  if (slides.length < 2) return;
  let current = 0;
  let autoTimer;

  function goTo(i) {
    slides[current].classList.remove('is-active');
    if (thumbs[current]) thumbs[current].classList.remove('is-active');
    current = (i + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (thumbs[current]) thumbs[current].classList.add('is-active');
  }

  function startAuto() { /* auto-rotate disabled so variant-selected image stays put */ }
  function resetAuto() { clearInterval(autoTimer); startAuto(); }

  const prev = document.querySelector('[data-gallery-prev]');
  const next = document.querySelector('[data-gallery-next]');
  if (prev) prev.addEventListener('click', () => { goTo(current - 1); resetAuto(); });
  if (next) next.addEventListener('click', () => { goTo(current + 1); resetAuto(); });
  thumbs.forEach(t => t.addEventListener('click', () => { goTo(parseInt(t.dataset.thumbIndex)); resetAuto(); }));
  startAuto();
}

/* ── PDP Quantity ── */
function initPdpQty() {
  const minus = document.querySelector('[data-qty-minus]');
  const plus = document.querySelector('[data-qty-plus]');
  const input = document.querySelector('[data-qty-input]');
  const hidden = document.querySelector('[data-pdp-qty-hidden]');
  if (!input) return;

  function update(v) {
    v = Math.max(1, Math.min(10, v));
    input.value = v;
    if (hidden) hidden.value = v;
  }
  if (minus) minus.addEventListener('click', () => update(parseInt(input.value) - 1));
  if (plus) plus.addEventListener('click', () => update(parseInt(input.value) + 1));
  input.addEventListener('change', () => update(parseInt(input.value) || 1));
}

/* ── PDP Tabs ── */
/* ── PDP Variant switcher ── */
function initPdpVariants() {
  const idInput = document.querySelector('[data-pdp-variant-id]');
  const dataEl = document.querySelector('[data-pdp-variant-data]');
  const optionBtns = document.querySelectorAll('.pdp__option-btn');
  if (!idInput || !dataEl || !optionBtns.length) return;
  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const priceEl = document.querySelector('.pdp__price');
  const wasEl = document.querySelector('.pdp__price-was');
  const badgeEl = document.querySelector('.pdp__price-badge');
  const cartBtn = document.querySelector('.pdp__btn--cart');
  const buyBtn = document.querySelector('.pdp__btn--buy');

  function selected() {
    const sel = [];
    document.querySelectorAll('.pdp__option-btn.is-active').forEach((b) => {
      sel[parseInt(b.dataset.optionIndex, 10)] = b.dataset.value;
    });
    return sel;
  }

  function update() {
    const sel = selected();
    const match = variants.find((v) =>
      v.options.every((o, i) => sel[i] === undefined || o === sel[i])
    );
    if (!match) return;
    idInput.value = match.id;
    if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
    if (wasEl) {
      if (match.compare_formatted) { wasEl.textContent = match.compare_formatted; wasEl.style.display = ''; }
      else { wasEl.style.display = 'none'; }
    }
    if (badgeEl) {
      if (match.compare && match.compare > match.price) {
        badgeEl.textContent = Math.round(((match.compare - match.price) / match.compare) * 100) + '% Off';
        badgeEl.style.display = '';
      } else { badgeEl.style.display = 'none'; }
    }
    const avail = match.available;
    [cartBtn, buyBtn].forEach((b) => { if (b) b.disabled = !avail; });
    if (cartBtn) { const s = cartBtn.querySelector('span'); if (s) s.textContent = avail ? 'Add to Cart' : 'Sold Out'; }
    // switch the gallery to this variant's image
    if (match.featured_image_id) {
      const thumb = document.querySelector('.pdp__thumb[data-image-id="' + match.featured_image_id + '"]');
      if (thumb) {
        thumb.click();
      } else {
        const slide = document.querySelector('.pdp__gallery-slide[data-image-id="' + match.featured_image_id + '"]');
        if (slide) {
          document.querySelectorAll('.pdp__gallery-slide').forEach((s) => s.classList.remove('is-active'));
          slide.classList.add('is-active');
        }
      }
    }
  }

  optionBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.optionIndex;
      document.querySelectorAll('.pdp__option-btn[data-option-index="' + idx + '"]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      update();
    });
  });

  update();
}

function initPdpTabs() {
  const nav = document.querySelector('[data-tabs-nav]');
  if (!nav) return;
  nav.querySelectorAll('[data-tab-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.tabBtn;
      nav.querySelectorAll('[data-tab-btn]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      document.querySelectorAll('[data-tab-panel]').forEach(p => {
        p.classList.toggle('is-active', p.dataset.tabPanel === idx);
      });
    });
  });
}

/* ── PDP Countdown ── */
function initPdpCountdown() {
  const el = document.querySelector('[data-countdown-hours]');
  if (!el) return;
  const hrs = parseInt(el.dataset.countdownHours) || 8;
  const key = 'pdp_countdown_end';
  let end = parseInt(sessionStorage.getItem(key));
  if (!end || end < Date.now()) {
    end = Date.now() + hrs * 3600000;
    sessionStorage.setItem(key, end);
  }
  function tick() {
    const diff = Math.max(0, end - Date.now());
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const pad = n => String(n).padStart(2, '0');
    const dEl = el.querySelector('[data-cd-days]');
    const hEl = el.querySelector('[data-cd-hours]');
    const mEl = el.querySelector('[data-cd-mins]');
    const sEl = el.querySelector('[data-cd-secs]');
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
}

/* ── PDP Buy Now ── */
function initPdpBuyNow() {
  const btn = document.querySelector('[data-pdp-buy-now]');
  if (!btn) return;
  btn.addEventListener('click', async () => {
    const form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const id = form.querySelector('[data-pdp-variant-id]');
    const qty = form.querySelector('[data-pdp-qty-hidden]');
    if (!id) return;
    const fallback = '/cart/' + id.value + ':' + (qty ? qty.value : 1);
    btn.setAttribute('disabled', '');
    try {
      // Add to cart first, then route through the standard checkout button
      // so Razorpay Magic Checkout intercepts it (same path as the cart drawer).
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id.value, quantity: qty ? parseInt(qty.value, 10) : 1 })
      });
      if (!res.ok) throw new Error('add failed');
      const checkoutBtn = document.querySelector('.cart-drawer__checkout')
        || document.querySelector('form[action="/cart"] [name="checkout"]');
      if (checkoutBtn) {
        checkoutBtn.click(); // Magic Checkout hooks this; falls back to native /checkout if Magic is off
      } else {
        window.location.href = '/checkout';
      }
    } catch (e) {
      window.location.href = fallback; // never leave the button dead
    } finally {
      btn.removeAttribute('disabled');
    }
  });
}

/* ── PDP Share ── */
function initPdpShare() {
  const btn = document.querySelector('[data-share-btn]');
  if (!btn) return;
  btn.addEventListener('click', () => {
    if (navigator.share) {
      navigator.share({ title: document.title, url: window.location.href });
    } else {
      navigator.clipboard.writeText(window.location.href);
      btn.querySelector('span').textContent = 'Link Copied!';
      setTimeout(() => { btn.querySelector('span').textContent = 'Share'; }, 2000);
    }
  });
}

/* ── Mobile Nav ── */
function initMobileNav() {
  const nav = document.querySelector('.mobile-nav');
  if (!nav) return;
  document.querySelectorAll('[data-mobile-open]').forEach(btn => {
    btn.addEventListener('click', () => { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  });
  document.querySelectorAll('[data-mobile-close]').forEach(btn => {
    btn.addEventListener('click', () => { nav.classList.remove('is-open'); document.body.style.overflow = ''; });
  });
  nav.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => { nav.classList.remove('is-open'); document.body.style.overflow = ''; });
  });
}

/* variant-switcher v1 */
